import { render, staticRenderFns } from "./DeclaranteIngreso.vue?vue&type=template&id=09d65baa&"
import script from "./DeclaranteIngreso.vue?vue&type=script&lang=js&"
export * from "./DeclaranteIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports